import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { UserShortModel } from 'src/app/models/user-short.model';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { IndependenceModel } from '../../declaration.model';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css'],
})
export class EmployeeComponent implements OnInit {
  @Input() employeeIndependence: IndependenceModel;
  @Input() isMyReport: boolean;
  employeeList: UserShortModel[];

  selectedProfile = '1';
  selectedEmployee;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedEmployee="";
    if (!this.isMyReport) {
      this.onProfileChanged();
    }
  }

  onProfileChanged() {
    if (this.selectedProfile != null && this.selectedProfile != undefined) {
      this.masterDataService
        .getUserByProfile(this.selectedProfile)
        .subscribe((res) => {
          //this.reportList =res[0].role;
          this.employeeList = res;
        });
    }
  }
  onViewReport() {
    if (
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedEmployee == null ||
      this.selectedEmployee == undefined ||
      this.selectedEmployee== ""
    )
       this.commonMessageService.swalAlertWithoutIcon('','Please Select Employee Name');
    else {
      this.masterDataService
        .getEmployeeIndependence(this.selectedEmployee.id, this.selectedProfile)
        .subscribe((res) => {
          //this.reportList =res[0].role;
          this.employeeIndependence = res;
          console.log('emp declare rep',this.employeeIndependence);
          if(this.employeeIndependence==null){
             this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
            this.showExcelButton=false;
          }else{
            this.showExcelButton=true;
          }
        });
    }
  }
  validateAggreQuestion(answer){
    if(answer==1){
      return true;
    }else{
      return false;
    }
  }

  showExcelButton:Boolean;
  onExportToExcelReport(){
    this.masterDataService.getEmployeeJoiningDeclarationExcel(this.selectedEmployee.id, this.selectedProfile).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "EmployeeJoiningDeclaration.xlsx";
      link.click();
    });
  }
  
  exportToPDFClick(){
    var docDefinition = {
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Employee Independence Confirmation', fontSize: 18, bold: true, alignment: 'center', margin: [0, 15, 0, 15] });
    docDefinition.content.push({text: `Name of Article/Employee/Partner:${'                      '}${this.employeeIndependence.firstName} ${this.employeeIndependence.lastName}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Designation:${'                                                              '} ${this.employeeIndependence.role}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Date Of Joining:${'                                                         '}${moment(this.employeeIndependence.joiningDate).format('DD-MMM-yyyy')}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `Branch:${'                                                                        '}${this.employeeIndependence.branch}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: 'DETAILED DECLARATIONS',margin:[0, 15, 0, 5]});
    docDefinition.content.push({text: `${this.employeeIndependence.beginText}`,bold:true,margin:[0, 5, 0, 10]});

    docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [40, '*', 60],
          body: [
            [{ text: 'Sr. No', bold:true, margin: [0, 5, 0, 5] }, { text: 'Declaration', bold:true, margin: [0, 5, 0, 5] }, { text: '	Agree / Disagree', bold:true, margin: [0, 5, 0, 5] }],
            ...this.employeeIndependence.empIndepenDeclarationDetails.map((res,index) => [{ text:index+1 }, { text: res.question},  { text: `${res.answer?'Yes':'No'}`}]),
           
          ]
        }
      }
      );
      docDefinition.content.push({text: 'Explanation in cases where disagree responses are given',margin:[0, 15, 0, 0],bold:true});
      docDefinition.content.push({text: `${this.employeeIndependence.dissagreementAnswer}`,margin:[0, 5, 0, 10]});
      docDefinition.content.push({text: `${this.employeeIndependence.declaration}`,margin:[0, 15, 0, 10],bold:true});
      docDefinition.content.push({text: 'REPRESENTATION',margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `${this.employeeIndependence.endText}`,margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `Sign:${'                      '} Yes`,margin: [0, 5, 0,4]});
      docDefinition.content.push({text: `Date:${'                       '}${moment(this.employeeIndependence.signedDate).format('DD-MMM-yyyy')}`,margin:[0, 0, 0, 4]});

    pdfMake.createPdf(docDefinition).download('EmployeeJoiningDeclaration.pdf');
  
  }
}
